import { useQuery, useQueryClient } from '@tanstack/react-query';
import { ContactEditModal } from '../../sites/components/ContactEditModal';
import { ConfirmProvider } from '../../../components/ui/confirm-dialog';
import { sitesService } from '../../../services/sitesService';

// JIM-1027-13 (Jim 10/27): "I should edit right here and that should pop up
// right here… don't take me anywhere… those are real people." The site's
// contact tool (the same one as the site page: switches, edit, remove, pick,
// new contact) opened over the Send to Client sheet, the ten-minute hold and
// the dashboard's unsent rows. A send reads the list when it goes, so a
// change made while a report is queued is what the client gets.
export function ReportRecipientsEditor({
  siteId,
  organizationId,
  inspectionId,
  onClose,
}: {
  siteId: string;
  organizationId?: string | null;
  /** The report whose recipient list is being changed; its list refetches on close. */
  inspectionId?: string | null;
  onClose: () => void;
}) {
  const queryClient = useQueryClient();
  const { data: siteContacts } = useQuery({
    queryKey: ['site-contacts', siteId],
    queryFn: () => sitesService.getContacts(siteId),
    enabled: !!siteId,
    retry: 1,
  });
  const { data: site } = useQuery({
    queryKey: ['site-detail', siteId],
    queryFn: () => sitesService.getSite(siteId),
    enabled: !!siteId,
    retry: 1,
    staleTime: 60_000,
  });
  const close = () => {
    if (inspectionId) {
      queryClient.invalidateQueries({
        queryKey: ['report-recipients', inspectionId],
      });
    }
    queryClient.invalidateQueries({
      queryKey: ['site-report-recipients', siteId],
    });
    queryClient.invalidateQueries({ queryKey: ['lite-unsent-reports'] });
    onClose();
  };
  return (
    <ConfirmProvider>
      <ContactEditModal
        editContactModal={{ type: 'site_contact' }}
        onClose={close}
        siteId={siteId}
        siteContacts={siteContacts}
        organizationId={
          organizationId ??
          (site?.organization_id ? String(site.organization_id) : undefined)
        }
        mailsEveryone={!!site && site.transition_phase !== 'live'}
        initialMode="view"
      />
    </ConfirmProvider>
  );
}
